module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Chappaquiddick.153ca6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Chappaquiddick.jpg
// module id = rSP9
// module chunks = 0